exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".line[data-v-2d305f4e]{display:flex;align-items:center;padding-bottom:16px}.line>div[data-v-2d305f4e]{flex:1}.title[data-v-2d305f4e]{display:block;padding:0 0 6px 0}\n", ""]);

